import React from 'react';

const BreadcrumbItem = ({ children }) => {
  return (
    <span>
      <span className="breadcrumb-link">{children}</span>
      <span className="breadcrumb-separator">/</span>
    </span>
  );
};

const Breadcrumb = ({ children }) => {
  return <div className="breadcrumb">{children}</div>;
};

export { Breadcrumb, BreadcrumbItem };

export default Breadcrumb;
